const ipPacs = '192.168.0.226';
export default ipPacs